<template>
  <div class="aside" style="height: 100%; width: 100%">
    <el-row class="tac" style="height: 100%; width: 100%">
      <el-col :span="12" style="height: 100%; width: 100%">
        <!-- <el-menu default-active="this.$route.path" router class="el-menu-vertical-demo" @open="handleOpen"
          @close="handleClose" background-color="#FFFFFF" text-color="#54545D" active-text-color="#1877FF"
          style="height: 100%; width: 100%;"> -->
        <!-- <el-menu :default-active="$route.path" :key="$route.fullPath" router class="el-menu-vertical-demo"
					@open="handleOpen" @close="handleClose" background-color="#FFFFFF" text-color="#54545D"
					active-text-color="#1877FF" style="height: 100%; width: 100%;"> -->
        <el-menu
          :default-active="activeMenuPath"
          router
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#FFFFFF"
          text-color="#54545D"
          active-text-color="#409EFF"
          style="height: 100%; width: 100%"
        >
          <el-menu-item index="/create">
            <i class="el-icon-circle-plus-outline"></i>
            <span slot="title">创建问卷</span>
          </el-menu-item>
          <el-menu-item index="/HomePage">
            <i class="el-icon-document-remove"></i>
            <span slot="title">问卷模版</span>
          </el-menu-item>
          <el-menu-item index="/MyPage">
            <i class="el-icon-user"></i>
            <span slot="title">我的问卷</span>
          </el-menu-item>
          <el-menu-item index="/DataStatisticsPage">
            <i class="el-icon-receiving"></i>
            <span slot="title">数据统计</span>
          </el-menu-item>
          <el-menu-item index="/libraryList">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">题库列表</span>
          </el-menu-item>
          <el-menu-item index="/libraryEntry">
            <i class="el-icon-folder-add"></i>
            <span slot="title">添加题型</span>
          </el-menu-item>
          <el-menu-item index="/RecyclePage">
            <i class="el-icon-delete"></i>
            <span slot="title">回收站</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  computed: {
    // activeMenuPath() {
    // 	const firstPath = this.$route.path.split('/')[1];
    // 	return '/' + firstPath;
    // }
    activeMenuPath() {
      console.log("看看卡看看");
      if (localStorage.getItem("token")) {
        const path = this.$route.path;
        if (path === "/" || path === "/home") {
          return "/HomePage";
        }
        const firstPath = path.split("/")[1];
        return "/" + firstPath;
      } else {
        this.$router.replace("/");
      }
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
span {
  font-size: 15px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/asideNav.vue